<template>
  <div class="ranking-display">
    <img :src="require('@/assets/daping/xcmx.png')" class="xcmx-img" v-if="imgType != '1'"/>
    <img :src="require('@/assets/daping/zgxqy.png')" class="zgxqy-img" v-else/>
    <div class="ranking-data">
      <div v-for="(item, index) in rankingDataList" :key="index" class="list">
        <img :src="item.img" class="ranking-data-img" />
        <div class="name-num">
          <div class="name">{{ item.label }}</div>
          <div class="num" v-if="!isName">
            <span v-if="!isValue">
              {{ item.autoComputedRate }}%
            </span>
            <span v-else>
              {{ item.value }}条
            </span>
            </div>
          <div class="num" v-else>{{ item.value2 }}人</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  props: {
    rankingDataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    imgType: {
      type: String,
      default: "",
    },
    isName: {
      type: Boolean,
      default: false
    },
    isValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.ranking-display {
  width: 732px;
  height: 104px;
  margin-top: 8px;
  background: linear-gradient(0deg, rgba(0, 163, 255, 0) 0%, rgba(0, 163, 255, 0.1) 100%);
  border-radius: 4px;
  backdrop-filter: blur(4px);
  padding: 14px 0 12px 12px;
  display: flex;
  .xcmx-img {
    width: 80px;
    height: 78px;
    margin-right: 23px;
  }
  .zgxqy-img {
    width: 112px;
    height: 78px;
    margin-right: 15px;
  }
  .ranking-data {
    display: flex;
    flex: 1;
    .list {
      display: flex;
      align-items: center;
      width: 33.3%;
      .name-num {
        margin: 0 0 0 12px;
      }
      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #adc2d3;
        line-height: 26px;
      }
      .num {
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 16px;
        color: #e4f2ff;
        line-height: 26px;
        margin-top: 6px;
      }
    }
    .ranking-data-img {
      width: 79px;
      height: 64px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/ranking-display.vue